
        import '/home/builduser/work/5d4c7c61b0622e62/santa-editor/packages/leftBar/leftBarMenu/leftBarMenu.scss.css.virtualfile';
        module.exports = {"wrapper":"_wrapper_m5ees_7","list":"_list_m5ees_18","item":"_item_m5ees_25","primary":"_primary_m5ees_32"};